import React, { useState } from 'react';
import { Modal, Table, Row, Col, Button } from 'react-bootstrap';
import { eventDateFormatter } from "@/components/pdp/pdpComponents/utils";

const BidHistoryModal = ({ show, handleClose, addresDetails, bidHistory }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 6;

    const getFormatPrice = amount => {
        if (amount?.length === 0 || isNaN(amount)) {
            return "";
        }
        return amount?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    };


const formatDateTime = (input) => {
  const date = new Date(input);
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
  const formattedTime = `${hours}:${minutes} ${ampm}`;

  return `${month}/${day}/${year} ${formattedTime}`;
};

// Example usage
// const input = "Jun-18-2025 00:41:57";
// const formatted = formatDateTime(input);
// console.log(formatted); // Output: 06/18/2025 12:41 AM


    const totalItems = bidHistory?.bidHistoryList?.length || 0;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const paginatedData = bidHistory?.bidHistoryList?.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton className="border-bottom py-3 add-agent-license">
                <Modal.Title className="p-1 row mb-0 add-agent-license-title roboto-regular">
                    Bid History {addresDetails ? `: ${addresDetails}` : ""}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='sectionContainer pt20'>
                    <Table bordered hover>
                        <thead>
                            <tr>
                                <th className='tableHead'>Date / Time (ET)</th>
                                <th className='tableHead'>Bidder</th>
                                <th className='tableHead'>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedData?.length > 0 ? (
                                paginatedData.map((item, index) => (
                                    <tr key={index}>
                                        <td className='tableTxt'>{formatDateTime(item?.bidSubmitDateNewFormat)}</td>
                                        <td className='tableTxt'>{item?.bidderName}</td>
                                        <td className='tableTxt'>{item?.bidAmount}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center">No bid history available.</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                    {/* Pagination Controls */}
                    {totalPages > 1 && (
                        <div className="d-flex justify-content-center mt-3">
                            <nav>
                                <ul className="pagination custom-pagination">
                                    {[...Array(totalPages)].map((_, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                                            onClick={() => handlePageChange(index + 1)}
                                        >
                                            <button className="page-link">{index + 1}</button>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </div>

                    )}
                </div>

                <Row className='p20'>
                    <Col xs={4}>
                        <p className="historyNote">Total Bids: {bidHistory?.totalBids}</p>
                    </Col>
                    <Col xs={8}>
                        <p className="historyNote">Number of Bidders: {bidHistory?.numberOfBidders}</p>
                    </Col>
                </Row>

                {/* <div className="mt-4 d-flex justify-content-center">
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </div> */}
            </Modal.Body>
        </Modal>
    );
};

export default BidHistoryModal;
